<div class="card-single" *ngIf="!pane || !pane.loaded else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>

<ng-template #contentBlock>
  <app-breadcrumbs></app-breadcrumbs>
</ng-template>
